import styled, { css } from 'styled-components';
import StackContainer from '@ad-scripts/presentation/components/common/containers/stack_container';

const fullHeightLayoutCss = css`
  height: calc(100vh - 110px);
  min-height: 540px;
`;

const TableLayout = styled(StackContainer).attrs({ stack: 'none', inset: 'none' })`
  background-color: ${p => p.theme.colors.white};
  border-radius: ${p => p.theme.borderRadius.large};
  box-shadow: ${p => p.theme.boxShadow.default};
  flex-shrink: 1;
  height: fit-content;
  margin: 24px 8px 24px 4px;
  max-width: 1200px;
  min-height: 0;
  overflow: hidden;
  width: 100%;

  ${({ showFullHeightLayout }) => (showFullHeightLayout ? fullHeightLayoutCss : '')};

  @media (max-width: 1280px) {
    margin-right: 16px;
  }
`;
export default TableLayout;
